import { render, staticRenderFns } from "./HighlightsXIcon.vue?vue&type=template&id=1d3488fe"
import script from "./HighlightsXIcon.vue?vue&type=script&lang=ts"
export * from "./HighlightsXIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports